import { differenceInDays, endOfDay, getHours, getMinutes, parseISO } from 'date-fns';

import { ILoyaltyBetweenDates } from 'generated/sanity-graphql';
import { LoyaltyOffer, RuleType } from 'state/loyalty/types';

export interface IEndingTime {
  days: number;
  hours: number;
  minutes?: number;
}

export function incentiveValidUntil(offer: LoyaltyOffer): IEndingTime | null {
  const loyaltyBetweenDates = offer.rules?.find(
    rule => rule?.__typename === RuleType.LoyaltyBetweenDates
  );

  if (!loyaltyBetweenDates) {
    return null;
  }

  const { endDate: endTimeString } = loyaltyBetweenDates as ILoyaltyBetweenDates;

  if (!endTimeString) {
    return null;
  }

  const now = new Date();
  // Using endOfDay due BetweenDates rule always considers the end of day (23:59:59)
  const endTime = endOfDay(parseISO(endTimeString));
  const endTimeHours = getHours(endTime);
  const endTimeMinutes = getMinutes(endTime);

  const diffInHours = endTimeHours - getHours(now);
  const diffInMinutes = endTimeMinutes - getMinutes(now);
  const diffInDays = differenceInDays(endTime, now);

  return {
    days: diffInDays,
    hours: diffInHours,
    minutes: diffInMinutes,
  };
}
